import React from "react";
import { Button, ButtonGroup, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const DeniedUrlsActionCell = props => (
  <Row style={{ marginLeft: "-3px", float: "right" }}>
    <ButtonGroup size="sm">
      <Button
        onClick={props.onDelete}
        id="dropdown-basic-button2"
        className="btn-red"
      >
        <FontAwesomeIcon icon={faTrash} />
      </Button>
    </ButtonGroup>
  </Row>
);

export default withTranslation()(DeniedUrlsActionCell);
